// @ts-nocheck

import { SportIds } from '../types/sports';

// __('!short:Draw')
export const MainBetOutcomesBySport = {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  [SportIds.SOCCER]: ['1', '!short:Draw', '2'],
  [SportIds.ICEHOCKEY]: ['1', '!short:Draw', '2'],
  [SportIds.HANDBALL]: ['1', '!short:Draw', '2'],
  [SportIds.FLOORBALL]: ['1', '!short:Draw', '2'],
  [SportIds.RUGBY]: ['1', '!short:Draw', '2'],
  [SportIds.FIELD_HOCKEY]: ['1', '!short:Draw', '2'],
  [SportIds.WATERPOLO]: ['1', '!short:Draw', '2'],
  [SportIds.FUTSAL]: ['1', '!short:Draw', '2'],
  [SportIds.CHESS]: ['1', '!short:Draw', '2'],
  [SportIds.BEACH_SOCCER]: ['1', '!short:Draw', '2'],
  [SportIds.PESAPALLO]: ['1', '!short:Draw', '2'],
  [SportIds.KABADDI]: ['1', '!short:Draw', '2'],
  [SportIds.RUGBY_7S]: ['1', '!short:Draw', '2'],
  [SportIds.RUGBY_LEAGUE]: ['1', '!short:Draw', '2'],
};

export const DefaultMainBetOutcomes = ['1', '2'];
